import { ReactNode } from 'react';
import { withStyles } from 'vopay';
import { BodyText } from 'UI';
import styles from './ContactEditRow.module.scss';

const cn = withStyles(styles);

type ContactEditRowProps = {
  label: ReactNode;
  children: ReactNode;
  'data-testid': string;
};

/** One editable row of a contact card: the label on the left, the input on the right (Figma "Summary"). */
export default function ContactEditRow({ label, children, 'data-testid': testId }: ContactEditRowProps) {
  return (
    <div className={cn('row')} data-testid={testId}>
      <BodyText size="sm" weight="md" className={cn('label')}>
        {label}
      </BodyText>

      <div className={cn('field')}>{children}</div>
    </div>
  );
}
